/* eslint-disable no-unused-vars */
import { makeAutoObservable, runInAction } from "mobx";
import apiHandler from "../handlers/ApiHandler";

class AuthStore {
  user = {};
  userPreference = {};

  constructor() {
    makeAutoObservable(this);
    this.loadAuthStore();
  }

  loadAuthStore() {
    this.loadUser();
    this.loadPreference();
  }

  loadUser() {
    const userDataString = sessionStorage.getItem("userFinalSessionData");
    if (!userDataString) {
      console.log("No user session data found in sessionStorage!");
    }

    try {
      const userData = JSON.parse(userDataString);
      const storedUser = userData?.userData;

      if (storedUser) {
        // const decryptedUser = decryptData(storedUser);
        console.log("Rehydrated user profile data: ", storedUser);
        this.user = storedUser;
      } else {
        console.log("No valid user data found in session");
      }
    } catch (error) {
      console.error("Error parsing or decrypting user profile: ", error);
    }
  }

  loadPreference() {
    const storedPreference = sessionStorage.getItem("userFinalSessionData");
    if (storedPreference) {
      try {
        const parsedPreference = JSON.parse(storedPreference);
        console.log("Parsed preference: ", parsedPreference);

        const userPreference = parsedPreference.userPreference || {};
        console.log("Rehydration of user preference data:", userPreference);

        this.userPreference = {
          ...userPreference,
          theme: userPreference.theme || "light",
        };
      } catch (error) {
        console.error("Error parsing user session data:", error);
      }
    } else {
      this.userPreference = { theme: "light" };
    }
  }

  setUser(userData) {
    this.user = { ...this.user, ...userData };
  }

  getUser() {
    return this.user;
  }

  setPreference(userPreferenceData) {
    this.userPreference = { ...this.userPreference, ...userPreferenceData };
  }

  getPreference() {
    return this.userPreference;
  }

  async login(username, password) {
    try {
      const response = await apiHandler.post("/api/auth/login", {
        username,
        password,
      });
      runInAction(() => {
        this.setUser(response.user);
      });
      console.log("Login with the data: ", response);
      return response;
    } catch (error) {
      console.error("Login failed in authStore!", error);
      throw error;
    }
  }

  async logout() {
    try {
      await apiHandler.post("/api/auth/logout", {});
      const themeValue = sessionStorage.getItem("theme");

      localStorage.clear();

      sessionStorage.clear();
      sessionStorage.removeItem("REACT_QUERY_OFFLINE_CACHE");

      if (themeValue) {
        localStorage.setItem("theme", themeValue);
      }

      runInAction(() => {
        this.user = {};
        this.userPreference = { theme: "light" };
      });
      return true;
    } catch (error) {
      console.error("Logout error in authStore:", error);
      throw error;
    }
  }
}

const authStore = new AuthStore();
export default authStore;
